export class RateInfo {
  address: string;
  eth: number;
  eur: number;
  gbp: number;
  usd: number;
}
